const ButtonTitle = (title, keyword, isBundleOnly) => {
  const getOptionTitle = () => {
    if (!keyword) return title;
    const replaced = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regExp = new RegExp(replaced, "i");
    const matchedWord = title.match(regExp);
    return title.replace(matchedWord, `<b class="search_word">${matchedWord}</b>`)
  };

  const span = document.createElement('span');
  span.setAttribute('data-role', 'title');
  span.innerHTML = getOptionTitle();
  if (isBundleOnly) {
    const strong = document.createElement('strong');
    strong.classList.add('addoption');
    strong.textContent = '[추가구매상품] ';
    span.prepend(strong);
  }
  return span;
};

const ButtonSubTitle = () => {
  const i = document.createElement('i');
  i.setAttribute('data-role', 'prchOptTxt');
  return i;
};

const SoldOutText = () => {
  const span = document.createElement('span');
  span.setAttribute('data-role', 'prchOptDisabled');
  span.textContent = '매진';
  return span;
};

const OptionButton = (optionIndex, key, title, isSoldout, keyword, isBundleOnly) => {
  const button = document.createElement('button');
  button.setAttribute('type', 'button');
  button.setAttribute('data-role', 'prchSelItem');
  button.setAttribute('data-index', optionIndex);
  button.setAttribute('data-key', key);
  button.append(ButtonTitle(title, keyword, isBundleOnly), ButtonSubTitle());
  if (isSoldout) {
    button.append(SoldOutText());
    button.setAttribute('disabled', 'disabled');
  }
  return button;
};

const Option = (option, optionIndex, keyword) => {
  const { value, key } = option;
  const dealMax = option.dealMax || option.orderDealMax;
  const optionTitle = value || option.optionTitle.split('|').pop();
  const optionKey = key || option.optionNo;
  const isSoldout = dealMax ? dealMax.soldOut : false;
  const isBundleOnly = option.isBundleOnly || false;
  const li = document.createElement('li');
  li.dataset.optionno = optionKey;
  if (isSoldout) li.classList.add('soldout');
  li.append(OptionButton(optionIndex, optionKey, optionTitle, isSoldout, keyword, isBundleOnly));
  return li;
};

const OptionHTML = (option, optionIndex, keyword) => {
  return Option(option, optionIndex, keyword).outerHTML;
};

export default OptionHTML;

/**
 * depth 옵션 클릭
 * depth별 선택한 옵션 key 값을 배열로 저장
 */
export function selectOption(depth, optionIndex, optionKey, allDepthContainer) {
  function getSelectedIndexList() {
    const { purchaseOption } = TMON.oApp.htStorage;
    if (!purchaseOption) return [ optionKey ];

    const { aKeyList } = purchaseOption;
    return [ ...aKeyList.slice(0, depth), optionKey ];
  }

  if (depth === 0) {
    TMON.oApp.setStorage('selectedActionIndex', optionIndex);
  }
  TMON.oApp.setStorage('purchaseOption', {
    aKeyList: getSelectedIndexList(),
    nCurrentDepth: depth,
    allDepthContainer,
    event: allDepthContainer,
  });
}

export function selectAllDepth(allDepthContainer) {
  const { optionInfo: { selectedList } } = TMON.oApp.htStorage;
  const currentDepth = selectedList.length - 1;

  TMON.oApp.setStorage('purchaseOption', {
    aKeyList: selectedList.map(({ item }) => item.key || item.optionNo),
    nCurrentDepth: selectedList.length - 1,
    allDepthContainer,
    event: allDepthContainer,
  });

  for (let depth = 0; depth <= currentDepth; depth++) {
    TMON.oApp.oPurchaseSelector.renderOptionItem(depth);
    const depthList = [...document.querySelectorAll(`.dep-sel.dep${depth}`)];
    depthList.forEach(depthEl => {
      depthEl.classList.remove('open');
      const button = depthEl.children[0];
      const selected = selectedList[depth].item;
      button.removeAttribute('disabled');
      button.textContent = selected.value || selected.optionTitle.split('|').pop();
      if (selected.isBundleOnly) {
        const strong = document.createElement('strong');
        strong.classList.add('addoption');
        strong.textContent = '[추가구매상품] ';
        button.prepend(strong);
      }
    });
  }
}